import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import axios from 'axios';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CrcBankDetails from './crcBankDetails';
import CrcGeneralInformation from './crcGeneralInfo';
import CrcForeignAssets from './crcForeignAssets';
import CrcDifferentSource from './CrcDifferentSource';
import CrcTotalIncome from './crcTotalIncome';
import CrcIncomeTax from './crcIncomeTax';
import CrcTravelledOutsideIndia from './crcTravelledOutside';
import CrcDirector from './crcDirectorinIndia';
import CRCClientAddAdditional from './crcclientAddAdditional/index';
import buttonDisable from '../disableField/buttonDisable';
import {
    createGenInfoRequestSubmit,
    createGenInfoRequestSave,
    getGenInfoRequest,
} from '../../modules/checkListGenerator/store/actions/index';
import { CommonConfig } from '../../config/common-config';
import CancelDialog from '../cancelpopup/cancel';
import LoaderPopUp from '../loaderpopup/loader';
import SuccessPopUp from '../loaderpopup/success';
// import ErrorPopUp from '../../components/loaderpopup/error';
//import { dataValidationCheck } from './disableSumit';
import { userType } from '../../config/usertypeValue';
import { dataValidationCheck } from './submitButtonFunctionControll';
import SubmitButtonWarningPopUp from './submitFunctionWarningPopUp';
import { cacheservice } from '../../config/cacheservice';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
}));

export default function CrcAccordin(props, values) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [expanded, setExpanded] = React.useState('panel1');
    const [cancel, setCancel] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [apiData, setApiData] = React.useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const servicesID = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const panelindexupdate = useSelector((state) => state.geninforeducer.panelindexupdate);
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    const [updateValuesfromChild, setUpdateValuesfromChild] = React.useState('');
    const [checklistADD, setChecklistADD] = useState('');
    const [apicallFlag, setApicallFlag] = React.useState(false);
    const [panelIndex, setpanelIndex] = React.useState('');
    const [rerender, setRerender] = React.useState(false);
    const [showSubmitButtonWarning, setShowSubmitButtonWarning] = React.useState(false);
    // const vertical = 'top';
    // const horizontal = 'center';
    // const [updateStat, setUpdateStat] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [successpop2, setSuccessPop2] = useState(false);

    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const userValue = userType.historyStageId;
    //console.log("imcNameSelected:", imcNameSelected);
    const [irreleventFieldAccordingContainer, setIrreleventFieldAccordingContainer] = useState([]);
    const userTypeValue = userDetails.result && userDetails.result.data.features[0].branchName;

    const updateApiData = (data) => {
        setApiData(data);
    };

    const updateApiCall = (newValue, panelIndex) => {
        // console.log("after API call , from DB value ", newValue);
        setApicallFlag(newValue);
        // setpanelIndex(panelIndex);
        panelIndex = panelIndex;
    };

    const rerenderApi = (newValue) => {
        setRerender(newValue);
    };
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [checklist, setChecklist] = useState('');
    const statusId = checklist && checklist.currentStage && checklist.currentStage.id;
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const [relevanceList, setRelevanceList] = useState([
        { color: '#3ccbcb', name: 'Relevant' },
        { color: '#db466b', name: 'Irrelevant' },
        { color: '#FFC300', name: 'Partially Relevant' },
    ]);

    const [apiResponse, setApiResponse] = React.useState({
        question0: '',
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        question6: '',
        question7: '',
        question8: '',
    });

    useEffect(() => {
        // setShowLoader(true);

        let panel = 'panel3';
        // console.log('panel');
        //let panel = 'panel' + props.page;
        //console.log('userType.historyStageId, stageId', userValue, stageId)

        if (userValue <= stageId) {
            // console.log('history view panel3');

            if (userTypeValue === 'ITeC AM and above' && userType.value === 'L1 AM Confirmed') {
                // console.log('history view inside panel3 for ITECAM');

                setTimeout(() => {
                    axios
                        .get(
                            `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                                usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                            }/${serviceIdValue}`,
                            {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            }
                        )
                        .then((response) => {
                            // console.log('response269', response.data)
                            setChecklist(response.data);
                            setResponse(response);
                            setShowLoader(false);
                        })
                        .catch((error) => {
                            setShowLoader(false);
                        });
                }, 5000);
            } else {
                // console.log('history view inside panel3');

                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}/${userValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        let tempObj = response.data;
                        tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                        // console.log('JSON.parse(response.data)', tempObj);
                        setChecklist(tempObj);
                        setResponse(response);
                        setShowLoader(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                    });
            }
        } else {
            // console.log('active view for panel 3 ');
            setTimeout(() => {
                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        // console.log('responsepanel3', response.data)
                        setChecklist(response.data);
                        setResponse(response);
                        setShowLoader(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                    });
            }, 5000);
        }

        setExpanded(panel);

        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                setChecklistADD(response.data);
                setShowLoader(false);
            })
            .catch((error) => {
                setShowLoader(false);
            });
    }, [apicallFlag, userType.value]);

    const setResponse = (response) => {
        let resp = {
            question0: response.data.checklistJson.checklistL1.questions[0],
            question1: response.data.checklistJson.checklistL1,
            question2: response.data.checklistJson.checklistL1.questions[2].subQuestion,
            question3: response.data.checklistJson.checklistL1.questions[3],
            question4: response.data.checklistJson.checklistL1.questions,
            question5: response.data.checklistJson.checklistL1.questions,
            question6: response.data.checklistJson.checklistL1.questions,
            question7: response.data.checklistJson.checklistL1.questions,
            question8: response.data.checklistJson.checklistL1.questions[8].subQuestion,
        };
        setApiResponse(resp);

        dispatch(getGenInfoRequest(response.data.checklistJson.checklistL1));
    };

    useEffect(() => {
        // setShowLoader(true);
        let panel = panelindexupdate && panelindexupdate.panelID;
        // console.log('panel', panel);
        //let panel = 'panel' + props.page;
        // console.log("panelall");

        //console.log('userType.historyStageId, stageId', userValue, stageId)
        if (userValue <= stageId) {
            // console.log('history view');

            if (userTypeValue === 'ITeC AM and above' && userType.value === 'L1 AM Confirmed') {
                // console.log('history view inside for ITECAM');

                setTimeout(() => {
                    axios
                        .get(
                            `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                                usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                            }/${serviceIdValue}`,
                            {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            }
                        )
                        .then((response) => {
                            // console.log('response269', response.data)
                            setChecklist(response.data);
                            setResponse(response);
                            setShowLoader(false);
                        })
                        .catch((error) => {
                            setShowLoader(false);
                        });
                }, 5000);
            } else {
                // console.log('history view inside for panel all');

                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}/${userValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        let tempObj = response.data;
                        tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                        //console.log('JSON.parse(response.data)', tempObj)
                        setChecklist(tempObj);
                        setResponse(response);
                        setShowLoader(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                    });
            }
        } else {
            // console.log('active view for panel all ');

            setTimeout(() => {
                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        // console.log('response269', response.data)
                        setChecklist(response.data);
                        setResponse(response);
                        setShowLoader(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                    });
            }, 5000);
        }

        setExpanded(panel);

        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                setChecklistADD(response.data);
                setShowLoader(false);
            })
            .catch((error) => {
                setShowLoader(false);
            });
    }, [rerender, userType.value]);

    useEffect(() => {
        // setShowLoader(true);
        // console.log('panel');
        let panel = 'panel' + props.page;
        setExpanded(panel);
        // console.log('aaaaaaaaaaaa')

        // console.log('userType.historyStageId, stageId', userType.historyStageId, stageId);
        // console.log('userTypeValue, userType.value', userTypeValue, userType);

        if (userType.historyStageId <= stageId) {
            // console.log('history view');

            if (userTypeValue === 'ITeC AM and above' && userType.value === 'L1 AM Confirmed') {
                // console.log('history view inside for ITECAM');

                setTimeout(() => {
                    axios
                        .get(
                            `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                                usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                            }/${serviceIdValue}`,
                            {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            }
                        )
                        .then((response) => {
                            setChecklist(response.data);
                            setResponse(response);
                            setShowLoader(false);
                        })
                        .catch((error) => {
                            setShowLoader(false);
                        });
                }, 5000);
            } else {
                // console.log('history view inside for panel last');
                // console.log('userType.historyStageId, stageId', userType.historyStageId, stageId);
                // console.log('userTypeValue, userType.value', userTypeValue, userType);

                setShowLoader(true);

                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}/${userValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        let tempObj = response.data;
                        tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                        //console.log('JSON.parse(response.data)', tempObj)
                        setChecklist(tempObj);
                        setResponse(response);
                        setShowLoader(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                    });
            }
        } else {
            // console.log('active view for panel last ');

            setTimeout(() => {
                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        setChecklist(response.data);
                        setResponse(response);
                        setShowLoader(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                    });
            }, 5000);
        }

        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                setChecklistADD(response.data);
                setShowLoader(false);
            })
            .catch((error) => {
                setShowLoader(false);
            });
    }, [props, userToken, userType.value]);

    const handleClose = () => {
        setShowLoader(false);
        setShowLoaderSubmit(false);
    };
    const initialValues = {};

    let generalInfo = {
        firstName: checklist1que && checklist1que[0].fields[0].response,
        firstnameRelevance: checklist1que && checklist1que[0].fields[0].relevanceResponseCRC,
        firstnameRelevanceRemarks: checklist1que && checklist1que[0].fields[0].relevanceRemarksCRC,

        lastName: checklist1que && checklist1que[0].fields[1].response,
        lastnameRelevance: checklist1que && checklist1que[0].fields[1].relevanceResponseCRC,
        lastnameRelevanceRemarks: checklist1que && checklist1que[0].fields[1].relevanceRemarksCRC,

        fatherNamePan: checklist1que && checklist1que[0].fields[2].response,
        fatherNamePanRelevance: checklist1que && checklist1que[0].fields[2].relevanceResponseCRC,
        fatherNamePanRelevanceRemarks: checklist1que && checklist1que[0].fields[2].relevanceRemarksCRC,

        pan: checklist1que && checklist1que[0].fields[3].response,
        panRelevance: checklist1que && checklist1que[0].fields[3].relevanceResponseCRC,
        panRelevanceRemarks: checklist1que && checklist1que[0].fields[3].relevanceRemarksCRC,

        address1: checklist1que && checklist1que[0].fields[4].response,
        address1Relevance: checklist1que && checklist1que[0].fields[4].relevanceResponseCRC,
        address1RelevanceRemarks: checklist1que && checklist1que[0].fields[4].relevanceRemarksCRC,

        address2: checklist1que && checklist1que[0].fields[5].response,
        address2Relevance: checklist1que && checklist1que[0].fields[5].relevanceResponseCRC,
        address2RelevanceRemarks: checklist1que && checklist1que[0].fields[5].relevanceRemarksCRC,

        city: checklist1que && checklist1que[0].fields[6].response,
        cityRelevance: checklist1que && checklist1que[0].fields[6].relevanceResponseCRC,
        cityRelevanceRemarks: checklist1que && checklist1que[0].fields[6].relevanceRemarksCRC,

        state: checklist1que && checklist1que[0].fields[7].response,
        stateRelevance: checklist1que && checklist1que[0].fields[7].relevanceResponseCRC,
        stateRelevanceRemarks: checklist1que && checklist1que[0].fields[7].relevanceRemarksCRC,

        country: checklist1que && checklist1que[0].fields[8].response,
        countryRelevance: checklist1que && checklist1que[0].fields[8].relevanceResponseCRC,
        countryRelevanceRemarks: checklist1que && checklist1que[0].fields[8].relevanceRemarksCRC,

        pin: checklist1que && checklist1que[0].fields[9].response,
        pinRelevance: checklist1que && checklist1que[0].fields[9].relevanceResponseCRC,
        pinRelevanceRemarks: checklist1que && checklist1que[0].fields[9].relevanceRemarksCRC,

        dob: checklist1que && checklist1que[0].fields[10].response,
        dobRelevance: checklist1que && checklist1que[0].fields[10].relevanceResponseCRC,
        dobRelevanceRemarks: checklist1que && checklist1que[0].fields[10].relevanceRemarksCRC,

        mobileNo: checklist1que && checklist1que[0].fields[11].response,
        mobileNoRelevance: checklist1que && checklist1que[0].fields[11].relevanceResponseCRC,
        mobileNoRelevanceRemarks: checklist1que && checklist1que[0].fields[11].relevanceRemarksCRC,

        emailaddress: checklist1que && checklist1que[0].fields[12].response,
        emailaddressRelevance: checklist1que && checklist1que[0].fields[12].relevanceResponseCRC,
        emailaddressRelevanceRemarks: checklist1que && checklist1que[0].fields[12].relevanceRemarksCRC,

        passport: checklist1que && checklist1que[0].fields[13].response,
        passportRelevance: checklist1que && checklist1que[0].fields[13].relevanceResponseCRC,
        passportRelevanceRemarks: checklist1que && checklist1que[0].fields[13].relevanceRemarksCRC,

        govIDType: checklist1que && checklist1que[0].fields[14].response,

        govIDNumber: checklist1que && checklist1que[0].fields[15].response,
        govIDNumberRelevance: checklist1que && checklist1que[0].fields[15].relevanceResponseCRC,
        govIDNumberRelevanceRemarks: checklist1que && checklist1que[0].fields[15].relevanceRemarksCRC,

        URLValue: checklist1que && checklist1que[0].fields[16].response,
        radiodata: checklist1que && checklist1que[0].fields[17].response,

        GSTIN: checklist1que && checklist1que[0].fields[18].response,
        gstinRelevance: checklist1que && checklist1que[0].fields[18].relevanceResponseCRC,
        gstinRelevanceRemarks: checklist1que && checklist1que[0].fields[18].relevanceRemarksCRC,
        panFile:
            checklist1que &&
            checklist1que[0] &&
            checklist1que[0].fields &&
            checklist1que[0].fields[19] &&
            checklist1que[0].fields[19].response,
        aadharFile:
            checklist1que &&
            checklist1que[0] &&
            checklist1que[0].fields &&
            checklist1que[0].fields[20] &&
            checklist1que[0].fields[20].response,
        enrollmentFile:
            checklist1que &&
            checklist1que[0] &&
            checklist1que[0].fields &&
            checklist1que[0].fields[21] &&
            checklist1que[0].fields[21].response,
        gstFile:
            checklist1que &&
            checklist1que[0] &&
            checklist1que[0].fields &&
            checklist1que[0].fields[22] &&
            checklist1que[0].fields[22].response,
    };

    let bankDetailsArr = [];

    if (checklist1que && checklist1que[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[1].fields.length; i += 7) {
            let bankDetailsArrtemp = {
                bankName: checklist1que[1].fields[i].response,
                bankNameRelevance: checklist1que[1].fields[i].relevanceResponseCRC,
                bankNameRelevanceRemarks: checklist1que[1].fields[i].relevanceRemarksCRC,
                accountNumber: checklist1que[1].fields[i + 1].response,
                accountNoRelevance: checklist1que[1].fields[i + 1].relevanceResponseCRC,
                accountNoRelevanceRemarks: checklist1que[1].fields[i + 1].relevanceRemarksCRC,
                ifscCode: checklist1que[1].fields[i + 2].response,
                ifscCodeRelevance: checklist1que[1].fields[i + 2].relevanceResponseCRC,
                ifscCodeRelevanceRemarks: checklist1que[1].fields[i + 2].relevanceRemarksCRC,
                typeOfAcc: checklist1que[1].fields[i + 3].response,
                accTypeRelevance: checklist1que[1].fields[i + 3].relevanceResponseCRC,
                accTypeRelevanceRemarks: checklist1que[1].fields[i + 3].relevanceRemarksCRC,
                interestOfSavingsBank: checklist1que[1].fields[i + 4].response,
                jointAccNameRelevance: checklist1que[1].fields[i + 4].relevanceResponseCRC,
                jointAccNameRelevanceRemarks: checklist1que[1].fields[i + 4].relevanceRemarksCRC,
                checkedBank: checklist1que[1].fields[i + 5].response,
                checkedBankRelevance: checklist1que[1].fields[i + 5].relevanceResponseCRC,
                checkedBankRelevanceRemarks: checklist1que[1].fields[i + 5].relevanceRemarksCRC,
                bankStatementUpload:
                    checklist1que && checklist1que[1] && checklist1que[1].fields[i + 6] && checklist1que[1].fields[i + 6].response,
            };
            bankDetailsArr.push(bankDetailsArrtemp);
        }
    } else {
        let bankDetailsArrtemp = {
            bankName: '',
            bankNameRelevance: '',
            bankNameRelevanceRemarks: '',

            accountNumber: '',
            accountNoRelevance: '',
            accountNoRelevanceRemarks: '',

            ifscCode: '',
            ifscCodeRelevance: '',
            ifscCodeRelevanceRemarks: '',

            typeOfAcc: '',
            accTypeRelevance: '',
            accTypeRelevanceRemarks: '',

            interestOfSavingsBank: '',
            jointAccNameRelevance: '',
            jointAccNameRelevanceRemarks: '',

            checkedBank: '',
            checkedBankRelevance: '',
            checkedBankRelevanceRemarks: '',

            bankStatementUpload: '',
        };
        bankDetailsArr.push(bankDetailsArrtemp);
    }
    initialValues.bankDetails = bankDetailsArr;

    let incomeTaxValues = {
        incomeUserId: checklist1que && checklist1que[3].fields[1].response,
        userIdRelevance: checklist1que && checklist1que[3].fields[1].relevanceResponseCRC,
        userIdRelevanceRemarks: checklist1que && checklist1que[3].fields[1].relevanceRemarksCRC,

        incomePassword: checklist1que && checklist1que[3].fields[2].response,
        passwordRelevance: checklist1que && checklist1que[3].fields[2].relevanceResponseCRC,
        passwordRelevanceRemarks: checklist1que && checklist1que[3].fields[2].relevanceRemarksCRC,
    };

    let yesorNoType = {
        // Screen Income Tax     4
        incomeTaxType: checklist1que && checklist1que[3].fields[0].response,

        // Travel outside
        traveloutsideType: checklist1que && checklist1que[4].fields[0].response,

        // Director Company
        directorType: checklist1que && checklist1que[5].fields[0].response,

        // 7th screen
        assetradio: checklist1que && checklist1que[6].subQuestion[11].fields[0].response,

        // Total Income
        totalincomeradio: checklist1que && checklist1que[7].subQuestion[5].fields[0].response,
    };

    let travelOutsideArr = [];
    if (checklist1que && checklist1que[4].subQuestion[0].fields.length > 1) {
        for (let i = 0; i < checklist1que[4].subQuestion[0].fields.length; i += 2) {
            let travelOutsideArrtemp = {
                year: checklist1que[4].subQuestion[0].fields[i].response,
                yearRelevance: checklist1que[4].subQuestion[0].fields[i].relevanceResponseCRC,
                yearRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i].relevanceRemarksCRC,
                daysIndia: checklist1que[4].subQuestion[0].fields[i + 1].response,
                daysIndiaRelevance: checklist1que && checklist1que[4].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                daysIndiaRelevanceRemarks: checklist1que && checklist1que[4].subQuestion[0].fields[i + 1].relevanceRemarksCRC,
            };
            travelOutsideArr.push(travelOutsideArrtemp);
        }
    } else {
        let travelOutsideArrtemp = {
            year: '',
            yearRelevance: '',
            yearRelevanceRemarks: '',
            daysIndia: '',
            daysIndiaRelevance: '',
            daysIndiaRelevanceRemarks: '',
        };
        travelOutsideArr.push(travelOutsideArrtemp);
    }
    initialValues.travelOutside = travelOutsideArr;

    let directorArr = [];
    if (checklist1que && checklist1que[5].subQuestion[0].fields.length > 1) {
        for (let i = 0; i < checklist1que[5].subQuestion[0].fields.length; i += 4) {
            let directorArr1 = {
                companyName: checklist1que[5].subQuestion[0].fields[i].response,
                companyNameRelevance: checklist1que[5].subQuestion[0].fields[i].relevanceResponseCRC,
                companyNameRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i].relevanceRemarksCRC,

                panCompany: checklist1que[5].subQuestion[0].fields[i + 1].response,
                panCompanyRelevance: checklist1que[5].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                panCompanyRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 1].relevanceRemarksCRC,

                shares: checklist1que[5].subQuestion[0].fields[i + 2].response,
                sharesRelevance: checklist1que[5].subQuestion[0].fields[i + 2].relevanceResponseCRC,
                sharesRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 2].relevanceRemarksCRC,

                din: checklist1que[5].subQuestion[0].fields[i + 3].response,
                compDinRelevance: checklist1que[5].subQuestion[0].fields[i + 3].relevanceResponseCRC,
                compDinRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 3].relevanceRemarksCRC,
            };
            directorArr.push(directorArr1);
        }
    } else {
        let directorArr1 = {
            companyName: '',
            companyNameRelevance: '',
            companyNameRelevanceRemarks: '',

            panCompany: '',
            panCompanyRelevance: '',
            panCompanyRelevanceRemarks: '',

            shares: '',
            sharesRelevance: '',
            sharesRelevanceRemarks: '',

            din: '',
            compDinRelevance: '',
            compDinRelevanceRemarks: '',
        };
        directorArr.push(directorArr1);
    }
    initialValues.directorCompany = directorArr;

    let assetHomeArr1 = [];
    // Screen 7 -assetHome
    if (checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[0].subSubQuestions[0].fields.length; i += 9) {
            let assetHomeArr = {
                country: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].relevanceRemarksCRC,

                tpin: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].response,
                tpinRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                tpinRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,

                salA: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].response,
                salARelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].relevanceResponseCRC,
                salARelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].relevanceRemarksCRC,

                salB: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].response,
                salBRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].relevanceResponseCRC,
                salBRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].relevanceRemarksCRC,

                salC: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].response,
                salCRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].relevanceResponseCRC,
                salCRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].relevanceRemarksCRC,

                salD: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].response,
                salDRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].relevanceResponseCRC,
                salDRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].relevanceRemarksCRC,

                salE: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].response,
                salERelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].relevanceResponseCRC,
                salERelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].relevanceRemarksCRC,

                srcNature: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].response,
                srcNatureRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].relevanceResponseCRC,
                srcNatureRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].relevanceRemarksCRC,

                totIncome: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].response,
                totIncomeRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].relevanceResponseCRC,
                totIncomeRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].relevanceRemarksCRC,
            };
            assetHomeArr1.push(assetHomeArr);
        }
    } else {
        let assetHomeArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            tpin: '',
            tpinRelevance: '',
            tpinRelevanceRemarks: '',

            salA: '',
            salARelevance: '',
            salARelevanceRemarks: '',

            salB: '',
            salBRelevance: '',
            salBRelevanceRemarks: '',

            salC: '',
            salCRelevance: '',
            salCRelevanceRemarks: '',

            salD: '',
            salDRelevance: '',
            salDRelevanceRemarks: '',

            salE: '',
            salERelevance: '',
            salERelevanceRemarks: '',

            srcNature: '',
            srcNatureRelevance: '',
            srcNatureRelevanceRemarks: '',

            totIncome: '',
            totIncomeRelevance: '',
            totIncomeRelevanceRemarks: '',
        };
        assetHomeArr1.push(assetHomeArr);
    }
    initialValues.assetHome = assetHomeArr1;

    let assetNatureArr1 = [];
    // Screen 7 -assetNature
    if (checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[0].subSubQuestions[1].fields.length; i += 3) {
            let assetNatureArr = {
                incomeNature: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                incomeNatureRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,

                foreignAmount: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                foreignAmountRelevance:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                foreignAmountRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,

                foreignTaxes: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].response,
                foreignTaxesRelevance:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                foreignTaxesRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
            };
            assetNatureArr1.push(assetNatureArr);
        }
    } else {
        let assetNatureArr = {
            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',

            foreignAmount: '',
            foreignAmountRelevance: '',
            foreignAmountRelevanceRemarks: '',

            foreignTaxes: '',
            foreignTaxesRelevance: '',
            foreignTaxesRelevanceRemarks: '',
        };
        assetNatureArr1.push(assetNatureArr);
    }
    initialValues.assetNature = assetNatureArr1;

    let clientArr1 = [];
    if (checklist1que && checklist1que[6].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[1].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que[6].subQuestion[1].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[1].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i].relevanceRemarksCRC,

                entityNature: checklist1que[6].subQuestion[1].fields[i + 1].response,
                entityNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                entityNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 1].relevanceRemarksCRC,

                entityName: checklist1que[6].subQuestion[1].fields[i + 2].response,
                entityName1Relevance: checklist1que[6].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                entityName1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                entityAddress: checklist1que[6].subQuestion[1].fields[i + 3].response,
                entityAddress1Relevance: checklist1que[6].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                entityAddress1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                interestNature: checklist1que[6].subQuestion[1].fields[i + 4].response,
                interestNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                interestNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                date: checklist1que[6].subQuestion[1].fields[i + 5].response,
                date1Relevance: checklist1que[6].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                date1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                totInvestment: checklist1que[6].subQuestion[1].fields[i + 6].response,
                totInvestment1Relevance: checklist1que[6].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                totInvestment1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                interestIncome: checklist1que[6].subQuestion[1].fields[i + 7].response,
                interstIncome1Relevance: checklist1que[6].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                interstIncome1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 7].relevanceRemarksCRC,

                incomeNature: checklist1que[6].subQuestion[1].fields[i + 8].response,
                incomeNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 8].relevanceResponseCRC,
                incomeNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr1.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            entityNature: '',
            entityNature1Relevance: '',
            entityNature1RelevanceRemarks: '',

            entityName: '',
            entityName1Relevance: '',
            entityName1RelevanceRemarks: '',

            entityAddress: '',
            entityAddress1Relevance: '',
            entityAddress1RelevanceRemarks: '',

            interestNature: '',
            interestNature1Relevance: '',
            interestNature1RelevanceRemarks: '',

            date: '',
            date1Relevance: '',
            date1RelevanceRemarks: '',

            totInvestment: '',
            totInvestment1Relevance: '',
            totInvestment1RelevanceRemarks: '',

            interestIncome: '',
            interstIncome1Relevance: '',
            interstIncome1RelevanceRemarks: '',

            incomeNature: '',
            incomeNature1Relevance: '',
            incomeNature1RelevanceRemarks: '',
        };
        clientArr1.push(clientArr);
    }

    initialValues.client1 = clientArr1;

    let clientArr2 = [];

    if (checklist1que && checklist1que[6].subQuestion[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[2].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que[6].subQuestion[2].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[2].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[2].fields[i].relevanceRemarksCRC,

                propAddress: checklist1que[6].subQuestion[2].fields[i + 1].response,
                propAddressRelevance: checklist1que[6].subQuestion[2].fields[i + 1].relevanceResponseCRC,
                propAddressRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 1].relevanceRemarksCRC,

                ownership: checklist1que[6].subQuestion[2].fields[i + 2].response,
                ownershipRelevance: checklist1que[6].subQuestion[2].fields[i + 2].relevanceResponseCRC,
                ownershipRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 2].relevanceRemarksCRC,

                acqisitionDate: checklist1que[6].subQuestion[2].fields[i + 3].response,
                acqisitionDateRelevance: checklist1que[6].subQuestion[2].fields[i + 3].relevanceResponseCRC,
                acqisitionDateRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 3].relevanceRemarksCRC,

                totInvestment: checklist1que[6].subQuestion[2].fields[i + 4].response,
                totInvestmentRelevance: checklist1que[6].subQuestion[2].fields[i + 4].relevanceResponseCRC,
                totInvestmentRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 4].relevanceRemarksCRC,

                propIncome: checklist1que[6].subQuestion[2].fields[i + 5].response,
                propIncomeRelevance: checklist1que[6].subQuestion[2].fields[i + 5].relevanceResponseCRC,
                propIncomeRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 5].relevanceRemarksCRC,

                incomeNature: checklist1que[6].subQuestion[2].fields[i + 6].response,
                incomeNatureRelevance: checklist1que[6].subQuestion[2].fields[i + 6].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr2.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            propAddress: '',
            propAddressRelevance: '',
            propAddressRelevanceRemarks: '',

            ownership: '',
            ownershipRelevance: '',
            ownershipRelevanceRemarks: '',

            acqisitionDate: '',
            acqisitionDateRelevance: '',
            acqisitionDateRelevanceRemarks: '',

            totInvestment: '',
            totInvestmentRelevance: '',
            totInvestmentRelevanceRemarks: '',

            propIncome: '',
            propIncomeRelevance: '',
            propIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr2.push(clientArr);
    }
    initialValues.client2 = clientArr2;

    let clientArr3 = [];

    if (checklist1que && checklist1que[6].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[3].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[3].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[3].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i].relevanceRemarksCRC,

                assetName: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].response,
                assetNameRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].relevanceResponseCRC,
                assetNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].relevanceRemarksCRC,

                ownership: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].response,
                ownershipRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].relevanceResponseCRC,
                ownershipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].relevanceRemarksCRC,

                acqisitionDate: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].response,
                acqisitionDateRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].relevanceResponseCRC,
                acqisitionDateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].relevanceRemarksCRC,

                totInvestment: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].response,
                totInvestmentRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].relevanceResponseCRC,
                totInvestmentRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].relevanceRemarksCRC,

                assetIncome: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].response,
                assetIncomeRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].relevanceResponseCRC,
                assetIncomeRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].relevanceRemarksCRC,

                incomeNature: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr3.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            assetName: '',
            assetNameRelevance: '',
            assetNameRelevanceRemarks: '',

            ownership: '',
            ownershipRelevance: '',
            ownershipRelevanceRemarks: '',

            acqisitionDate: '',
            acqisitionDateRelevance: '',
            acqisitionDateRelevanceRemarks: '',

            totInvestment: '',
            totInvestmentRelevance: '',
            totInvestmentRelevanceRemarks: '',

            assetIncome: '',
            assetIncomeRelevance: '',
            assetIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr3.push(clientArr);
    }
    initialValues.client3 = clientArr3;

    let clientArr4 = [];

    if (checklist1que && checklist1que[6].subQuestion[4].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[4].fields.length; i += 5) {
            let clientArr = {
                institutionName: checklist1que && checklist1que[6].subQuestion[4].fields[i].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].relevanceRemarksCRC,

                accholderName: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].response,
                accholderNameRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].relevanceResponseCRC,
                accholderNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].relevanceRemarksCRC,

                peakBal: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].response,
                peakBalRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].relevanceResponseCRC,
                peakBalRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].relevanceRemarksCRC,
            };
            clientArr4.push(clientArr);
        }
    } else {
        let clientArr = {
            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            accholderName: '',
            accholderNameRelevance: '',
            accholderNameRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            peakBal: '',
            peakBalRelevance: '',
            peakBalRelevanceRemarks: '',
        };
        clientArr4.push(clientArr);
    }
    initialValues.client4 = clientArr4;

    let clientArr5 = [];

    if (checklist1que && checklist1que[6].subQuestion[5].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[5].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[5].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[5].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i].relevanceRemarksCRC,

                trustName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].response,
                trustNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                trustNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].relevanceRemarksCRC,

                trustAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].response,
                trustAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                trustAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].relevanceRemarksCRC,

                trusteeName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].response,
                trusteeNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                trusteeNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].relevanceRemarksCRC,

                trusteeAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].response,
                trusteeAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].relevanceResponseCRC,
                trusteeAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].relevanceRemarksCRC,

                settlorAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].response,
                settlorAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].relevanceResponseCRC,
                settlorAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].relevanceRemarksCRC,

                settlorName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].response,
                settlorNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].relevanceResponseCRC,
                settlorNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].relevanceRemarksCRC,

                benfName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].response,
                benfNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].relevanceResponseCRC,
                benfNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].relevanceRemarksCRC,

                benfAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].response,
                benfAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].relevanceResponseCRC,
                benfAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr5.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            trustName: '',
            trustNameRelevance: '',
            trustNameRelevanceRemarks: '',

            trustAddress: '',
            trustAddressRelevance: '',
            trustAddressRelevanceRemarks: '',

            trusteeName: '',
            trusteeNameRelevance: '',
            trusteeNameRelevanceRemarks: '',

            trusteeAddress: '',
            trusteeAddressRelevance: '',
            trusteeAddressRelevanceRemarks: '',

            settlorAddress: '',
            settlorAddressRelevance: '',
            settlorAddressRelevanceRemarks: '',

            settlorName: '',
            settlorNameRelevance: '',
            settlorNameRelevanceRemarks: '',

            benfName: '',
            benfNameRelevance: '',
            benfNameRelevanceRemarks: '',

            benfAddress: '',
            benfAddressRelevance: '',
            benfAddressRelevanceRemarks: '',
        };
        clientArr5.push(clientArr);
    }
    initialValues.client5 = clientArr5;

    let clientArr6 = [];

    if (checklist1que && checklist1que[6].subQuestion[6].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[6].fields.length; i += 5) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[6].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[6].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i].relevanceRemarksCRC,

                personName: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].response,
                personNameRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].relevanceResponseCRC,
                personNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].relevanceRemarksCRC,

                personAddr: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].response,
                personAddrRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].relevanceResponseCRC,
                personAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].relevanceRemarksCRC,

                derivedIncome: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].response,
                derivedIncomeRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].relevanceResponseCRC,
                derivedIncomeRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].relevanceRemarksCRC,

                incomeNature: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].relevanceRemarksCRC,
            };
            clientArr6.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            personName: '',
            personNameRelevance: '',
            personNameRelevanceRemarks: '',

            personAddr: '',
            personAddrRelevance: '',
            personAddrRelevanceRemarks: '',

            derivedIncome: '',
            derivedIncomeRelevance: '',
            derivedIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr6.push(clientArr);
    }
    initialValues.client6 = clientArr6;

    let clientArr7 = [];

    if (checklist1que && checklist1que[6].subQuestion[7].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[7].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[7].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[7].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i].relevanceRemarksCRC,

                institutionName: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].relevanceRemarksCRC,

                status: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].response,
                statusRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].relevanceResponseCRC,
                statusRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].relevanceRemarksCRC,

                date: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].response,
                dateRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].relevanceRemarksCRC,

                peakBalance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].response,
                peakBalanceRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].relevanceResponseCRC,
                peakBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr7.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            status: '',
            statusRelevance: '',
            statusRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            peakBalance: '',
            peakBalanceRelevance: '',
            peakBalanceRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',
        };
        clientArr7.push(clientArr);
    }
    initialValues.client7 = clientArr7;

    let clientArr8 = [];

    if (checklist1que && checklist1que[6].subQuestion[8].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[8].fields.length; i += 10) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[8].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[8].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i].relevanceRemarksCRC,

                institutionName: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].relevanceRemarksCRC,

                status: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].response,
                statusRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].relevanceResponseCRC,
                statusRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].relevanceRemarksCRC,

                date: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].response,
                dateRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].relevanceRemarksCRC,

                peakBalance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].response,
                peakBalanceRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].relevanceResponseCRC,
                peakBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].relevanceRemarksCRC,

                grossAmount: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].response,
                grossAmountRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].relevanceResponseCRC,
                grossAmountRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].relevanceRemarksCRC,
            };
            clientArr8.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            status: '',
            statusRelevance: '',
            statusRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            peakBalance: '',
            peakBalanceRelevance: '',
            peakBalanceRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',

            grossAmount: '',
            grossAmountRelevance: '',
            grossAmountRelevanceRemarks: '',
        };
        clientArr8.push(clientArr);
    }
    initialValues.client8 = clientArr8;

    let clientArr9 = [];

    if (checklist1que && checklist1que[6].subQuestion[9].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[9].fields.length; i += 10) {
            //console.log('...length9', checklist1que[6].subQuestion[9].fields.length);
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[9].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[9].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i].relevanceRemarksCRC,

                entityName: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].response,
                entityNameRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].relevanceResponseCRC,
                entityNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].relevanceRemarksCRC,

                entityAddress: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].response,
                entityAddressRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].relevanceResponseCRC,
                entityAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].relevanceRemarksCRC,

                entityNature: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].response,
                entityNatureRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].relevanceResponseCRC,
                entityNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].relevanceRemarksCRC,

                acquireDate: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].response,
                acquireDateRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].relevanceResponseCRC,
                acquireDateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].relevanceRemarksCRC,

                initialInvest: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].response,
                initialInvestRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].relevanceResponseCRC,
                initialInvestRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].relevanceRemarksCRC,

                peakInvest: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].response,
                peakInvestRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].relevanceResponseCRC,
                peakInvestRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].relevanceRemarksCRC,

                grossAmount: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].response,
                grossAmountRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].relevanceResponseCRC,
                grossAmountRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].relevanceRemarksCRC,
            };
            clientArr9.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            entityName: '',
            entityNameRelevance: '',
            entityNameRelevanceRemarks: '',

            entityAddress: '',
            entityAddressRelevance: '',
            entityAddressRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            entityNature: '',
            entityNatureRelevance: '',
            entityNatureRelevanceRemarks: '',

            acquireDate: '',
            acquireDateRelevance: '',
            acquireDateRelevanceRemarks: '',

            initialInvest: '',
            initialInvestRelevance: '',
            initialInvestRelevanceRemarks: '',

            peakInvest: '',
            peakInvestRelevance: '',
            peakInvestRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',

            grossAmount: '',
            grossAmountRelevance: '',
            grossAmountRelevanceRemarks: '',
        };
        clientArr9.push(clientArr);
    }
    initialValues.client9 = clientArr9;

    let clientArr10 = [];

    if (checklist1que && checklist1que[6].subQuestion[10].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[10].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que[6].subQuestion[10].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[10].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[10].fields[i].relevanceRemarksCRC,

                instiName: checklist1que[6].subQuestion[10].fields[i + 1].response,
                instiNameRelevance: checklist1que[6].subQuestion[10].fields[i + 1].relevanceResponseCRC,
                instiNameRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 1].relevanceRemarksCRC,

                instiAddr: checklist1que[6].subQuestion[10].fields[i + 2].response,
                instiAddrRelevance: checklist1que[6].subQuestion[10].fields[i + 2].relevanceResponseCRC,
                instiAddrRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que[6].subQuestion[10].fields[i + 3].response,
                zipRelevance: checklist1que[6].subQuestion[10].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 3].relevanceRemarksCRC,

                date: checklist1que[6].subQuestion[10].fields[i + 4].response,
                dateRelevance: checklist1que[6].subQuestion[10].fields[i + 4].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 4].relevanceRemarksCRC,

                cashValue: checklist1que[6].subQuestion[10].fields[i + 5].response,
                cashValueRelevance: checklist1que[6].subQuestion[10].fields[i + 5].relevanceResponseCRC,
                cashValueRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 5].relevanceRemarksCRC,

                grossValue: checklist1que[6].subQuestion[10].fields[i + 6].response,
                grossValueRelevance: checklist1que[6].subQuestion[10].fields[i + 6].relevanceResponseCRC,
                grossValueRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr10.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            instiName: '',
            instiNameRelevance: '',
            instiNameRelevanceRemarks: '',

            instiAddr: '',
            instiAddrRelevance: '',
            instiAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            cashValue: '',
            cashValueRelevance: '',
            cashValueRelevanceRemarks: '',

            grossValue: '',
            grossValueRelevance: '',
            grossValueRelevanceRemarks: '',
        };
        clientArr10.push(clientArr);
    }
    initialValues.client10 = clientArr10;

    let labelAdataArr = [];
    if (checklist1que && checklist1que[7].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[0].fields.length; i += 3) {
            let labelAdataArr1 = {
                description: checklist1que && checklist1que[7].subQuestion[0].fields[i].response,
                descriptionRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i].relevanceResponseCRC,
                descriptionRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i].relevanceRemarksCRC,

                address: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].response,
                addressRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                addressRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].relevanceRemarksCRC,

                amount: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].response,
                amountRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].relevanceResponseCRC,
                amountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].relevanceRemarksCRC,
            };
            labelAdataArr.push(labelAdataArr1);
        }
    } else {
        let labelAdataArr1 = {
            description: '',
            descriptionRelevance: '',
            descriptionRelevanceRemarks: '',
            address: '',
            addressRelevance: '',
            addressRelevanceRemarks: '',
            amount: '',
            amountRelevance: '',
            amountRelevanceRemarks: '',
        };
        labelAdataArr.push(labelAdataArr1);
    }
    initialValues.labelAdata = labelAdataArr;

    let labelBdataArr = [];

    if (checklist1que && checklist1que[7].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[1].fields.length; i += 8) {
            let labelBdataArr1 = {
                jewellaryBullions: (checklist1que && checklist1que[7].subQuestion[1].fields[i].response) || '',
                jewellaryBullionsRelevance: (checklist1que && checklist1que[7].subQuestion[1].fields[i].relevanceResponseCRC) || '',
                jewellaryBullionsRelevanceRemarks: (checklist1que && checklist1que[7].subQuestion[1].fields[i].relevanceRemarksCRC) || '',

                archaeologicalCollections: (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].response) || '',
                archaeologicalCollectionsRelevance:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].relevanceResponseCRC) || '',
                archaeologicalCollectionsRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].relevanceRemarksCRC) || '',

                vehiclesYatchBoatsAircrafts: (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].response) || '',
                vehiclesYatchBoatsAircraftsRelevance:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].relevanceResponseCRC) || '',
                vehiclesYatchBoatsAircraftsRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].relevanceRemarksCRC) || '',

                faAAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].response,
                faAAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                faAAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                faBAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].response,
                faBAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                faBAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                faCAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].response,
                faCAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                faCAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                faDAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].response,
                faDAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                faDAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                faEAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].response,
                faEAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                faEAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].relevanceRemarksCRC,
            };
            labelBdataArr.push(labelBdataArr1);
        }
    } else {
        let labelBdataArr1 = {
            jewellaryBullions: '',
            jewellaryBullionsRelevance: '',
            jewellaryBullionsRelevanceRemarks: '',
            archaeologicalCollections: '',
            archaeologicalCollectionsRelevance: '',
            archaeologicalCollectionsRelevanceRemarks: '',
            vehiclesYatchBoatsAircrafts: '',
            vehiclesYatchBoatsAircraftsRelevance: '',
            vehiclesYatchBoatsAircraftsRelevanceRemarks: '',
            faAAmount: '',
            faAAmountRelevance: '',
            faAAmountRelevanceRemarks: '',
            faBAmount: '',
            faBAmountRelevance: '',
            faBAmountRelevanceRemarks: '',
            faCAmount: '',
            faCAmountRelevance: '',
            faCAmountRelevanceRemarks: '',
            faDAmount: '',
            faDAmountRelevance: '',
            faDAmountRelevanceRemarks: '',
            faEAmount: '',
            faEAmountRelevance: '',
            faEAmountRelevanceRemarks: '',
        };
        labelBdataArr.push(labelBdataArr1);
    }
    initialValues.labelBdata = labelBdataArr;

    let labelCdataArr = [];
    if (checklist1que && checklist1que[7].subQuestion[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[2].fields.length; i += 16) {
            let labelCdataArr1 = {
                name: checklist1que && checklist1que[7].subQuestion[2].fields[i].response,
                nameCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i].relevanceResponseCRC,
                nameCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].response,
                panCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].relevanceResponseCRC,
                panCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].relevanceRemarksCRC,

                particularShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].response,
                particularShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].relevanceResponseCRC,
                particularShareCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].relevanceRemarksCRC,

                particularCost: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].response,
                particularCostCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].relevanceResponseCRC,
                particularCostCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].relevanceRemarksCRC,

                acquiredShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].response,
                acquiredShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].relevanceResponseCRC,
                acquiredShareCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].relevanceRemarksCRC,

                acquiredDate: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].response,
                acquiredDateCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].relevanceResponseCRC,
                acquiredDateCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].relevanceRemarksCRC,

                acquiredValue: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].response,
                acquiredValueCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].relevanceResponseCRC,
                acquiredValueCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].relevanceRemarksCRC,

                acquiredIssuePrice: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].response,
                acquiredIPCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].relevanceResponseCRC,
                acquiredIPCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].relevanceRemarksCRC,

                acquiredPurchasePrice: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].response,
                acquiredPPCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].relevanceResponseCRC,
                acquiredPPCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].relevanceRemarksCRC,

                transferredShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].response,
                tsCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].relevanceResponseCRC,
                tsCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].relevanceRemarksCRC,

                transferredSale: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].response,
                tsaleCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].relevanceResponseCRC,
                tsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].relevanceRemarksCRC,

                closingShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].response,
                closingShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].relevanceResponseCRC,
                closingSharetsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].relevanceRemarksCRC,

                closingCost: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].response,
                closingCostCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].relevanceResponseCRC,
                closingCostsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].relevanceRemarksCRC,

                closingSale: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].response,
                closingSaleCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].relevanceResponseCRC,
                closingSaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].relevanceRemarksCRC,

                noOfShare: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].response) || '',
                noOfShareCRelevance: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].relevanceResponseCRC) || '',
                noOfShareCRelevanceRemarks: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].relevanceRemarksCRC) || '',

                costOfAcquisition: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].response) || '',
                costOfAcquisitionCRelevance: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].relevanceResponseCRC) || '',
                costOfAcquisitionCRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].relevanceRemarksCRC) || '',
            };
            labelCdataArr.push(labelCdataArr1);
        }
    } else {
        let labelCdataArr1 = {
            name: '',
            nameCRelevance: '',
            nameCRelevanceRemarks: '',

            pan: '',
            panCRelevance: '',
            panCRelevanceRemarks: '',

            particularShare: '',
            particularShareCRelevance: '',
            particularShareCRelevanceRemarks: '',

            particularCost: '',
            particularCostCRelevance: '',
            particularCostCRelevanceRemarks: '',

            acquiredShare: '',
            acquiredShareCRelevance: '',
            acquiredShareCRelevanceRemarks: '',

            acquiredDate: '',
            acquiredDateCRelevance: '',
            acquiredDateCRelevanceRemarks: '',

            acquiredValue: '',
            acquiredValueCRelevance: '',
            acquiredValueCRelevanceRemarks: '',

            acquiredIssuePrice: '',
            acquiredIPCRelevance: '',
            acquiredIPCRelevanceRemarks: '',

            acquiredPurchasePrice: '',
            acquiredPPCRelevance: '',
            acquiredPPCRelevanceRemarks: '',

            transferredShare: '',
            tsCRelevance: '',
            tsCRelevanceRemarks: '',

            transferredSale: '',
            tsaleCRelevance: '',
            tsaleCRelevanceRemarks: '',

            closingShare: '',
            closingShareCRelevance: '',
            closingSharetsaleCRelevanceRemarks: '',

            closingCost: '',
            closingCostCRelevance: '',
            closingCostsaleCRelevanceRemarks: '',

            closingSale: '',
            closingSaleCRelevance: '',
            closingSaleCRelevanceRemarks: '',

            noOfShare: '',
            noOfShareCRelevance: '',
            noOfShareCRelevanceRemarks: '',

            costOfAcquisition: '',
            costOfAcquisitionCRelevance: '',
            costOfAcquisitionCRelevanceRemarks: '',
        };
        labelCdataArr.push(labelCdataArr1);
    }
    initialValues.labelCdata = labelCdataArr;

    let labelDdataArr = [];

    if (checklist1que && checklist1que[7].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[3].fields.length; i += 3) {
            let labelDdataArr1 = {
                name: checklist1que && checklist1que[7].subQuestion[3].fields[i].response,
                nameDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i].relevanceResponseCRC,
                nameDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].response,
                panDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].relevanceResponseCRC,
                panDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].relevanceRemarksCRC,

                value: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].response,
                valueDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].relevanceResponseCRC,
                valueDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].relevanceRemarksCRC,
            };
            labelDdataArr.push(labelDdataArr1);
        }
    } else {
        let labelDdataArr1 = {
            name: '',
            nameDRelevance: '',
            nameDRelevanceRemarks: '',

            pan: '',
            panDRelevance: '',
            panDRelevanceRemarks: '',

            value: '',
            valueDRelevance: '',
            valueDRelevanceRemarks: '',
        };
        labelDdataArr.push(labelDdataArr1);
    }

    initialValues.labelDdata = labelDdataArr;

    let labelEdataArr = [];
    if (checklist1que && checklist1que[7].subQuestion[4].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[4].fields.length; i += 2) {
            let labelEdataArr1 = {
                particular: checklist1que && checklist1que[7].subQuestion[4].fields[i].response,
                particularRelevance: checklist1que && checklist1que[7].subQuestion[4].fields[i].relevanceResponseCRC,
                particularRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[4].fields[i].relevanceRemarksCRC,

                amount: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].response,
                amountERelevance: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].relevanceResponseCRC,
                amountERelevanceRemarks: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].relevanceRemarksCRC,
            };
            labelEdataArr.push(labelEdataArr1);
        }
    } else {
        let labelEdataArr1 = {
            particular: '',
            particularRelevance: '',
            particularRelevanceRemarks: '',

            amount: '',
            amountERelevance: '',
            amountERelevanceRemarks: '',
        };
        labelEdataArr.push(labelEdataArr1);
    }
    initialValues.labelEdata = labelEdataArr;

    let thirdscreenvalues = {};

    // let TempPayLoad = {}
    // const createAPCallData = () => {
    // creating payLoad for third screen tab one
    thirdscreenvalues.nameEmployer = checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[1].response;
    thirdscreenvalues.nameEmployerCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceResponseCRC;
    thirdscreenvalues.nameEmployerCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceRemarksCRC;
    thirdscreenvalues.salaryradiodata = checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[0].response;
    thirdscreenvalues.url = checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[2].response;

    let investmentArr = [];
    if (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[0].subSubQuestions[1].fields.length; i += 3) {
            let investmentArrtemp = {
                investmentDetails: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].response,
                investmentDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                investmentDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                investmentAmt: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                investmentAmtCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                investmentAmtCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                invAmtUpload: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 2].response,
                // investmentAmtCRCRelevenceResponse:
                //     checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                // investmentAmtCRCRelevenceRemarks:
                //     checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
            };
            investmentArr.push(investmentArrtemp);
        }
    } else {
        let investmentArrtemp = {
            investmentDetails: '',
            investmentAmt: '',
        };
        investmentArr.push(investmentArrtemp);
    }
    thirdscreenvalues.investment = investmentArr;

    let donationArr = [];
    if (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[0].subSubQuestions[2].fields.length; i += 3) {
            let donationArrtemp = {
                donationDetails: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].response,
                donationDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceResponseCRC,
                donationDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                donationAmt: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].response,
                donationAmountCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].relevanceResponseCRC,
                donationAmountCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].relevanceRemarksCRC,
                donationAmtUpload: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 2].response,
                // donationAmountCRCRelevenceResponse:
                //     checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 2].relevanceResponseCRC,
                // donationAmountCRCRelevenceRemarks:
                //     checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 2].relevanceRemarksCRC,
            };
            donationArr.push(donationArrtemp);
        }
    } else {
        let donationArrtemp = {
            donationDetails: '',
            donationAmt: '',
        };
        donationArr.push(donationArrtemp);
    }
    thirdscreenvalues.donation = donationArr;

    // creating payload for third screen 2nd tab
    let housepropertyArr = [];
    if (checklist1que && checklist1que[2].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[1].fields.length; i += 14) {
            // let coownerArr = [];
            let housepropertyArrtemp = {
                houseAddress: checklist1que && checklist1que[2].subQuestion[1].fields[i].response,
                houseAddressCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i].relevanceResponseCRC,
                houseAddressCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i].relevanceRemarksCRC,

                houseStatusType: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].response,

                houseStatusTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                houseStatusTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].relevanceRemarksCRC,

                rent: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].response,
                rentCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                rentCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                propTax: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].response,
                propTaxCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                propTaxCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].relevanceRemarksCRC,
                tenantName: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].response,
                tenantNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                tenantNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].response,
                panCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                panCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                housepurposeType: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].response,
                housepurposeTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                housepurposeTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                propertyCoOwnedType: checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].response,
                propertyCoOwnedTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].relevanceResponseCRC,
                propertyCoOwnedTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].relevanceRemarksCRC,

                haveyoutakenanyhousingloanType: checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].response,
                haveyoutakenanyhousingloanTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].relevanceResponseCRC,
                haveyoutakenanyhousingloanTypeCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].relevanceRemarksCRC,

                rentUpload: checklist1que[2].subQuestion[1].fields[i + 7].response,
                propertyUpload: checklist1que[2].subQuestion[1].fields[i + 9].response,

                loanUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].response,
                loanUploadCRCrelevenceResponse:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].relevanceResponseCRC,
                loanUploadCRCrelevenceRemarks:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].relevanceRemarksCRC,

                TDSUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].response,
                TDSUploadCRCrelevenceResponse:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].relevanceResponseCRC,
                TDSUploadCRCrelevenceRemarks:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].relevanceRemarksCRC,

                uploadCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                uploadCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 7].relevanceRemarksCRC,

                TDSdeductedinrentType: checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].response,
                TDSdeductedinrentTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].relevanceResponseCRC,
                TDSdeductedinrentTypeCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].relevanceRemarksCRC,
                coowner: [],
            };
            if (checklist1que && checklist1que[2].subQuestion[1].subSubQuestions.length > 0) {
                let coOwnerList = [];
                for (let j = 0; j < checklist1que[2].subQuestion[1].subSubQuestions.length; j += 3) {
                    if (
                        checklist1que &&
                        checklist1que[2].subQuestion[1].subSubQuestions[j].sectionText.split('-').pop() == housepropertyArr.length
                    ) {
                        let coOwner = {
                            coownerName: checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].response,
                            coownerNameCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].relevanceResponseCRC,
                            coownerNameCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].relevanceRemarksCRC,
                            coownerPan: checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].response,
                            coownerPanCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].relevanceResponseCRC,
                            coownerPanCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].relevanceRemarksCRC,
                            share: checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].response,
                            shareCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].relevanceResponseCRC,
                            shareCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].relevanceRemarksCRC,
                        };
                        coOwnerList.push(coOwner);
                    }
                }
                housepropertyArrtemp.coowner = coOwnerList;
            }
            housepropertyArr.push(housepropertyArrtemp);
        }
    } else {
        let housepropertyArrtemp = {
            houseAddress: '',
            houseStatusType: '',
            rent: '',
            propTax: '',
            tenantName: '',
            pan: '',
            housepurposeType: '',
            propertyCoOwnedType: '',
            coowner: [
                {
                    coownerName: '',
                    coownerPan: '',
                    share: '',
                },
            ],
            haveyoutakenanyhousingloanType: '',
            rentUpload: '',
            TDSdeductedinrentType: '',
            propertyUpload: '',
            loanUpload: '',
            TDSUpload: '',
        };
        housepropertyArr.push(housepropertyArrtemp);
    }
    thirdscreenvalues.houseproperty = housepropertyArr;
    thirdscreenvalues.incomeFromHouseProperty = (checklist1que && checklist1que[2].subQuestion[1].response) || 'Yes';
    // creating payload for third screen 3rd tab
    thirdscreenvalues.incomeFromBusinessProfesion = (checklist1que && checklist1que[2].subQuestion[2].response) || 'Yes';
    thirdscreenvalues.natureBusiness = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].response;
    thirdscreenvalues.natureBusinessCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceResponseCRC;
    thirdscreenvalues.natureBusinessCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceRemarksCRC;
    thirdscreenvalues.busProfincomeType = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].response;
    thirdscreenvalues.busProfincomeTypeCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceResponseCRC;
    thirdscreenvalues.busProfincomeTypeCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceRemarksCRC;
    thirdscreenvalues.totalReceipts = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].response;
    thirdscreenvalues.totalReceiptsCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceResponseCRC;
    thirdscreenvalues.totalReceiptsCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceRemarksCRC;
    thirdscreenvalues.totalExpenses = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].response;
    thirdscreenvalues.totalExpensesCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceResponseCRC;
    thirdscreenvalues.totalExpensesCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceRemarksCRC;
    thirdscreenvalues.gstReturnDoc = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].response;
    thirdscreenvalues.gstReturnDocCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceResponseCRC;
    thirdscreenvalues.gstReturnDocCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceRemarksCRC;
    thirdscreenvalues.otherStatement = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].response;
    thirdscreenvalues.otherStatementCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceResponseCRC;
    thirdscreenvalues.otherStatementCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceRemarksCRC;
    thirdscreenvalues.busProfType = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].response;
    thirdscreenvalues.busProfTypeCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceResponseCRC;
    thirdscreenvalues.busProfTypeCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceRemarksCRC;
    thirdscreenvalues.userIDtally = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].response;
    thirdscreenvalues.userIDtallyCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceResponseCRC;
    thirdscreenvalues.userIDtallyCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceRemarksCRC;
    thirdscreenvalues.passwordtally = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].response;
    thirdscreenvalues.passwordtallyCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceResponseCRC;
    thirdscreenvalues.passwordtallyCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceRemarksCRC;
    thirdscreenvalues.uploadTally = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].response;
    thirdscreenvalues.uploadTallyCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceResponseCRC;
    thirdscreenvalues.uploadTallyCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceRemarksCRC;

    thirdscreenvalues.userIDZoho = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].response;
    thirdscreenvalues.userIDZohoCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceResponseCRC;
    thirdscreenvalues.userIDZohoCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceRemarksCRC;

    thirdscreenvalues.passwordZoho = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].response;
    thirdscreenvalues.passwordZohoCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceResponseCRC;
    thirdscreenvalues.passwordZohoCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceRemarksCRC;

    thirdscreenvalues.userIDQB = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].response;
    thirdscreenvalues.userIDQBCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceResponseCRC;
    thirdscreenvalues.userIDQBCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceRemarksCRC;

    thirdscreenvalues.passwordQB = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].response;
    thirdscreenvalues.passwordQBCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceResponseCRC;
    thirdscreenvalues.passwordQBCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceRemarksCRC;

    thirdscreenvalues.accountDetails = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].response;
    thirdscreenvalues.accountDetailsCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceResponseCRC;
    thirdscreenvalues.accountDetailsCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceRemarksCRC;
    thirdscreenvalues.partnershipradio = checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].response;
    thirdscreenvalues.partnershipradioCRCrelevenceResponse =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceResponseCRC;
    thirdscreenvalues.partnershipradioCRCrelevenceRemarks =
        checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceRemarksCRC;
    let tallyYesArr = [];
    if (checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[2].subSubQuestions[1].fields.length; i += 9) {
            //console.log('Hema.....', checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i]);
            let tallyYesArrtemp = {
                nameFirm: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].response,
                nameFirmCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceResponseCRC,
                nameFirmCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                panNoFirm: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].response,
                panNoFirmCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                panNoFirmCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                remunRec: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].response,
                remunRecCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                remunRecCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
                amtInt: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].response,
                amtIntCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].relevanceResponseCRC,
                amtIntCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].relevanceRemarksCRC,
                shareProfit: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].response,
                shareProfitCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].relevanceResponseCRC,
                shareProfitCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].relevanceRemarksCRC,
                shareProfitRs: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].response,
                shareProfitRsCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].relevanceResponseCRC,
                shareProfitRsCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].relevanceRemarksCRC,
                firmAudit: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].response,
                firmAuditCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].relevanceResponseCRC,
                firmAuditCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].relevanceRemarksCRC,
                transferPrice: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].response,
                transferPriceCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].relevanceResponseCRC,
                transferPriceCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].relevanceRemarksCRC,
                balance: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].response,
                balanceCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].relevanceResponseCRC,
                balanceCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].relevanceRemarksCRC,
            };
            tallyYesArr.push(tallyYesArrtemp);
        }
    } else {
        let tallyYesArrtemp = {
            nameFirm: '',
            panNoFirm: '',
            remunRec: '',
            amtInt: '',
            shareProfit: '',
            shareProfitRs: '',
            firmAudit: '',
            transferPrice: '',
            balance: '',
        };
        tallyYesArr.push(tallyYesArrtemp);
    }
    thirdscreenvalues.tallyYes = tallyYesArr;
    // screen 3 - Tab 4 -capital gain
    let capitalgainArr = [];
    if (checklist1que && checklist1que[2].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[3].fields.length; i += 2) {
            let capitalgainArrtemp = {
                natureAssets: checklist1que && checklist1que[2].subQuestion[3].fields[i].response,
                balanceCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[3].fields[i].relevanceResponseCRC,
                balanceCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[3].fields[i].relevanceRemarksCRC,
                natureAssetsUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[3] &&
                    checklist1que[2].subQuestion[3].fields[i + 1] &&
                    checklist1que[2].subQuestion[3].fields[i + 1].response,
            };
            capitalgainArr.push(capitalgainArrtemp);
        }
    } else {
        let capitalgainArrtemp = {
            natureAssets: '',
            natureAssetsUpload: '',
        };
        capitalgainArr.push(capitalgainArrtemp);
    }
    thirdscreenvalues.capitalgain = capitalgainArr;
    thirdscreenvalues.soldAnyAsset = (checklist1que && checklist1que[2].subQuestion[3].response) || 'Yes';

    // screen 3 -Tab 5 - other source
    let dividentArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[0].fields.length; i += 3) {
            let dividenttempArr = {
                divPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].response,
                divPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceResponseCRC,
                divPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                divAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].response,
                divAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                divAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,
                divUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 2].response,
            };
            dividentArr.push(dividenttempArr);
        }
    } else {
        let dividenttempArr = {
            divPayer: '',
            divAmount: '',
            divUpload: '',
        };
        dividentArr.push(dividenttempArr);
    }
    thirdscreenvalues.divident = dividentArr;
    let fdArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[1].fields.length; i += 3) {
            let fdtempArr = {
                fdPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].response,
                fdPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceResponseCRC,
                fdPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                fdAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].response,
                fdAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                fdAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                fdUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 2].response,
            };
            fdArr.push(fdtempArr);
        }
    } else {
        let fdtempArr = {
            fdPayer: '',
            fdAmount: '',
            fdUpload: '',
        };
        fdArr.push(fdtempArr);
    }
    thirdscreenvalues.fd = fdArr;
    let othersArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[2].fields.length; i += 3) {
            let othertempArr = {
                otherPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].response,
                otherPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceResponseCRC,
                otherPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                otherAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].response,
                otherAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].relevanceResponseCRC,
                otherAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].relevanceRemarksCRC,
                otherUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 2].response,
            };
            othersArr.push(othertempArr);
        }
    } else {
        let othertempArr = {
            otherPayer: '',
            otherAmount: '',
            otherUpload: '',
        };
        othersArr.push(othertempArr);
    }
    thirdscreenvalues.othersources = othersArr;
    thirdscreenvalues.explicitlyUncoveredIncom = (checklist1que && checklist1que[2].subQuestion[4].response) || 'Yes';

    // screen 3 - Tab 6 - Agri
    const agricultureArr = [];
    if (checklist1que && checklist1que[2].subQuestion[5].fields.length > 1) {
        //console.log('Field Length', checklist1que[4].fields.length);
        for (let i = 0; i < checklist1que[2].subQuestion[5].fields.length; i += 6) {
            const agricultureArrtemp = {
                agricultureName: (checklist1que && checklist1que[2].subQuestion[5].fields[i].response) || '',
                agricultureNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceResponseCRC,
                agricultureNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceRemarksCRC,
                agriAmount: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].response) || '',
                agriAmountCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                agriAmountCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceRemarksCRC,
                agriReceipt: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].response) || '',
                agriReceiptCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                agriReceiptCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceRemarksCRC,
                agriExpenses: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].response) || '',
                agriExpensesCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                agriExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceRemarksCRC,
                agriReceiptUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 4].response) || '',
                agriExpensesUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 5].response) || '',
            };
            agricultureArr.push(agricultureArrtemp);
        }
    } else {
        const agricultureArrtemp = {
            agricultureName: '',
            agriAmount: '',
            agriReceipt: '',
            agriExpenses: '',
            agriReceiptUpload: '',
            agriExpensesUpload: '',
        };
        agricultureArr.push(agricultureArrtemp);
    }
    thirdscreenvalues.agriculture = agricultureArr;
    thirdscreenvalues.agricultureIncome = (checklist1que && checklist1que[2].subQuestion[5].response) || 'Yes';
    // thirdscreenvalues.agricultureName = checklist1que && checklist1que[2].subQuestion[5].fields[0].response;
    // thirdscreenvalues.agricultureNameCRCrelevenceResponse = checklist1que && checklist1que[2].subQuestion[5].fields[0].relevanceResponseCRC;
    // thirdscreenvalues.agricultureNameCRCrelevenceRemarks = checklist1que && checklist1que[2].subQuestion[5].fields[0].relevanceRemarksCRC;
    // thirdscreenvalues.agriAmount = checklist1que && checklist1que[2].subQuestion[5].fields[1].response;
    // thirdscreenvalues.agriAmountCRCrelevenceResponse = checklist1que && checklist1que[2].subQuestion[5].fields[1].relevanceResponseCRC;
    // thirdscreenvalues.agriAmountCRCrelevenceRemarks = checklist1que && checklist1que[2].subQuestion[5].fields[1].relevanceRemarksCRC;
    // thirdscreenvalues.agriReceipt = checklist1que && checklist1que[2].subQuestion[5].fields[2].response;
    // thirdscreenvalues.agriReceiptCRCrelevenceResponse = checklist1que && checklist1que[2].subQuestion[5].fields[2].relevanceResponseCRC;
    // thirdscreenvalues.agriReceiptCRCrelevenceRemarks = checklist1que && checklist1que[2].subQuestion[5].fields[2].relevanceRemarksCRC;
    // thirdscreenvalues.agriExpenses = checklist1que && checklist1que[2].subQuestion[5].fields[3].response;
    // thirdscreenvalues.agriExpensesCRCrelevenceResponse = checklist1que && checklist1que[2].subQuestion[5].fields[3].relevanceResponseCRC;
    // thirdscreenvalues.agriExpensesCRCrelevenceRemarks = checklist1que && checklist1que[2].subQuestion[5].fields[3].relevanceRemarksCRC;
    //console.log('main index file thirdscreenvalues:', thirdscreenvalues);
    // };

    // screen 3 - Tab 6 - Deduction
    const investmentArr1 = [];

    if (checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[6].subSubQuestions[0].fields.length; i += 3) {
            let investmentArrtemp = {
                investmentDetails: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].response,
                investmentDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceResponseCRC,
                investmentDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                investmentAmt: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].response,
                investmentAmtCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                investmentAmtCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,
                invAmtUpload: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 2].response,
            };
            investmentArr1.push(investmentArrtemp);
        }
    } else {
        const investmentArrtemp = {
            investmentDetails: '',
            investmentAmt: '',
            invAmtUpload: '',
        };
        investmentArr1.push(investmentArrtemp);
    }
    thirdscreenvalues.investment1 = investmentArr1;

    const donationArr1 = [];

    if (checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[6].subSubQuestions[1].fields.length; i += 3) {
            const donationArrtemp = {
                donationDetails: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].response,
                donationDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceResponseCRC,
                donationDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                donationAmt: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].response,
                donationAmountCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                donationAmountCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                donationAmtUpload: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 2].response,
            };
            donationArr1.push(donationArrtemp);
        }
    } else {
        const donationArrtemp = {
            donationDetails: '',
            donationAmt: '',
            donationAmtUpload: '',
        };
        donationArr1.push(donationArrtemp);
    }
    thirdscreenvalues.donation1 = donationArr1;

    // 9th screen data
    let additionalQueData = [];
    if (checklist1que && checklist1que[8].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[8].subQuestion[0].fields.length; i++) {
            let additionalQueDataJson = {
                response: checklist1que[8].subQuestion[0].fields[i].response,
                questionId: checklist1que[8].subQuestion[0].fields[i].relevanceRemarksAM,
                questionText: checklist1que[8].subQuestion[0].fields[i].relevanceResponseAM,
                relevanceRemarksCRC: checklist1que[8].subQuestion[0].fields[i].relevanceRemarksCRC,
                relevanceResponseCRC: checklist1que[8].subQuestion[0].fields[i].relevanceResponseCRC,
            };
            additionalQueData.push(additionalQueDataJson);
        }
    } else {
        let additionalQueDataJson = {
            response: '',
            questionId: '',
            questionText: '',
            relevanceRemarksCRC: '',
            relevanceResponseCRC: '',
        };
        additionalQueData.push(additionalQueDataJson);
    }

    initialValues.additionalQue = additionalQueData;

    const dbValuesforque6 = {
        apiResponse: apiResponse.question6,
        ...generalInfo,
        ...incomeTaxValues,
        bankDetails: initialValues.bankDetails,
        ...thirdscreenvalues,
        travelOutside: initialValues.travelOutside,
        directorCompany: initialValues.directorCompany,
        assetHome: initialValues.assetHome,
        assetNature: initialValues.assetNature,
        client1: initialValues.client1,
        client2: initialValues.client2,
        client3: initialValues.client3,
        client4: initialValues.client4,
        client5: initialValues.client5,
        client6: initialValues.client6,
        client7: initialValues.client7,
        client8: initialValues.client8,
        client9: initialValues.client9,
        client10: initialValues.client10,
        labelAdata: initialValues.labelAdata,
        labelBdata: initialValues.labelBdata,
        labelCdata: initialValues.labelCdata,
        labelDdata: initialValues.labelDdata,
        labelEdata: initialValues.labelEdata,
    };

    let dbValuesforque7 = {
        apiResponse: apiResponse.question7,
        ...generalInfo,
        ...incomeTaxValues,
        bankDetails: initialValues.bankDetails,
        ...thirdscreenvalues,
        travelOutside: initialValues.travelOutside,
        directorCompany: initialValues.directorCompany,
        assetHome: initialValues.assetHome,
        assetNature: initialValues.assetNature,
        client1: initialValues.client1,
        client2: initialValues.client2,
        client3: initialValues.client3,
        client4: initialValues.client4,
        client5: initialValues.client5,
        client6: initialValues.client6,
        client7: initialValues.client7,
        client8: initialValues.client8,
        client9: initialValues.client9,
        client10: initialValues.client10,
        labelAdata: initialValues.labelAdata,
        labelBdata: initialValues.labelBdata,
        labelCdata: initialValues.labelCdata,
        labelDdata: initialValues.labelDdata,
        labelEdata: initialValues.labelEdata,
    };

    const handleSubmitClickforL2 = (updateValuesfromChild) => {
        if (updateValuesfromChild.prop) {
            let data = {
                ...updateValuesfromChild.prop,
            };
            dispatch(
                createGenInfoRequestSave({
                    params: data,
                    bearerToken,
                    serviceIdValue: servicesID,
                    usertype,
                    imcNameSelected: imcNameSelected,
                    statusIDValue: usertype === 'EM' ? 10 : 5,
                })
            );
            setShowLoader(true);
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
            setTimeout(() => {
                setSuccessPop2(true);
            }, 4000);
            setTimeout(() => {
                // history.push({
                //     pathname: '/menu/openservice',
                // });
                history.push({
                    pathname: '/menu/openserviceall',
                    state: { domainname: imcNameSelected },
                });
            }, 7000);
        } else {
            let payload = {
                ...generalInfo,
                ...incomeTaxValues,
                ...initialValues,
                ...thirdscreenvalues,
                ...yesorNoType,
            };
            dispatch(
                createGenInfoRequestSave({
                    params: payload,
                    bearerToken,
                    serviceIdValue: servicesID,
                    usertype,
                    imcNameSelected: imcNameSelected,
                    statusIDValue: usertype === 'EM' ? 10 : 5,
                })
            );
            setShowLoader(true);
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
            setTimeout(() => {
                setSuccessPop2(true);
            }, 4000);
            setTimeout(() => {
                // history.push({
                //     pathname: '/menu/openservice',
                // });
                history.push({
                    pathname: '/menu/openserviceall',
                    state: { domainname: imcNameSelected },
                });
            }, 7000);
        }
    };

    const handleSubmitClick = (updateValuesfromChild) => {
        setShowLoader(true);

        // console.log('updateValuesfromChild', updateValuesfromChild);
        setIrreleventFieldAccordingContainer([]);
        let isSuccess = true;
        let irrevelentFieldContainer = [];

        if (updateValuesfromChild.prop) {
            let data = {
                ...updateValuesfromChild.prop,
                ...thirdscreenvalues,
            };
            // console.log('datadata', data);

            // console.log("datadata:", data);
            if (stageId === 5) {
                let irrevelentFieldContainer = dataValidationCheck(checklist, stageId);
                if (irrevelentFieldContainer.length > 0) {
                    setIrreleventFieldAccordingContainer(FieldCheck(irrevelentFieldContainer));
                    //console.log("call error popUP")
                    setTimeout(() => {
                        setShowLoader(false);
                        setShowSubmitButtonWarning(true);
                    }, 15000);
                } else {
                    //console.log("dispatch methode");
                    setCRCValue(data);
                }
            } else if (stageId === 3 || stageId === 4 || stageId === 7 || stageId === 8) {
                // console.log('1 st submit');

                let irrevelentFieldContainer = dataValidationCheck(checklist, stageId);

                if (irrevelentFieldContainer.length > 0) {
                    setIrreleventFieldAccordingContainer(FieldCheck(irrevelentFieldContainer));
                    //console.log("call error popUP")
                    setTimeout(() => {
                        setShowLoader(false);
                        setShowSubmitButtonWarning(true);
                    }, 15000);
                } else {
                    //console.log("dispatch methode");
                    setCRCValue(data);
                }
            } else {
                setCRCValue(data);
            }
        } else {
            let payload = {
                ...generalInfo,
                ...incomeTaxValues,
                ...initialValues,
                ...thirdscreenvalues,
                ...yesorNoType,
            };
            ////console.log("data:",payload);
            if (stageId === 5) {
                let irrevelentFieldContainer = dataValidationCheck(checklist, stageId);
                if (irrevelentFieldContainer.length > 0) {
                    setIrreleventFieldAccordingContainer(FieldCheck(irrevelentFieldContainer));
                    //console.log("call error popUP")
                    setTimeout(() => {
                        setShowLoader(false);
                        setShowSubmitButtonWarning(true);
                    }, 15000);
                } else {
                    //console.log("dispatch methode");
                    setCRCValue(payload);
                }
            } else if (stageId === 3 || stageId === 4 || stageId === 7 || stageId === 8) {
                // console.log('2nd submit');

                let irrevelentFieldContainer = dataValidationCheck(checklist, stageId);
                if (irrevelentFieldContainer.length > 0) {
                    setIrreleventFieldAccordingContainer(FieldCheck(irrevelentFieldContainer));
                    //console.log("call error popUP")
                    setTimeout(() => {
                        setShowLoader(false);
                        setShowSubmitButtonWarning(true);
                    }, 15000);
                } else {
                    //console.log("dispatch methode");
                    setCRCValue(payload);
                }
            } else {
                setCRCValue(payload);
            }
        }
    };

    function FieldCheck(a) {
        let tempRelevanceField = [];
        a.filter((ele, i) => {
            if (
                ele === 'Details of Income accuring or arising outside India' ||
                ele === 'Details of financial interest in any entity' ||
                ele === 'Details of immovable property' ||
                ele === 'Details of any others capital asset held at any time during the previous year' ||
                ele === 'Details of accounts in which you are a signing authority, which is not part of any of above list' ||
                ele === 'Details of Trust created outside India, in which you are a trustee' ||
                ele === 'Details of any other income derived from any other source outside India which is not included above' ||
                ele === 'Details of foreign depository accounts held (including any beneficial interest) at any time during the year' ||
                ele === 'Details of foreign custodial accounts held (including any beneficial interest) at any time during the year' ||
                ele ===
                    'Details of foreign equity and debt interest held (including any beneficial interest) in any entity at any time during the year' ||
                ele ===
                    'Details of foreign cash value insurance contract or annuity contract held (including any beneficial interest) at any time during the year'
            ) {
                tempRelevanceField.push('Details of Foreign Assets');
            } else if (
                ele === 'Details of immovable assets' ||
                ele === 'Details of movable asset' ||
                ele === 'Whether you have held unlisted equity shares at any time during the previous year' ||
                ele === 'Interest held in the assets of a firm or association of persons (AOP) as a partner or member thereof' ||
                ele === 'Liabilities(if any) relating to the above assets at A,B and C'
            ) {
                tempRelevanceField.push('Personal Assets');
            } else {
                tempRelevanceField.push(ele);
            }
        });
        var seen = {};
        var out = [];
        var len = tempRelevanceField.length;
        var j = 0;
        for (var i = 0; i < len; i++) {
            var item = tempRelevanceField[i];
            if (seen[item] !== 1) {
                seen[item] = 1;
                out[j++] = item;
            }
        }
        return out;
    }

    const setCRCValue = (data) => {
        // console.log('setCRCValue', data);

        dispatch(
            createGenInfoRequestSubmit({
                params: data,
                bearerToken,
                serviceIdValue: servicesID,
                usertype,
                imcNameSelected,
                statusIDValue:
                    usertype === 'EM' ? 10 : '' || usertype === 'ITeC AM and above' ? 5 : '' || usertype === 'Itec Team' ? 8 : '',
            })
        );
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
        }, 2000);
        setTimeout(() => {
            setSuccessPop(true);
        }, 3000);
        setTimeout(() => {
            history.push({
                pathname: '/menu/openserviceall',
                state: { domainname: imcNameSelected },
            });
        }, 7000);
    };

    const handleCloseSubmitButtonErrorPopUP = () => {
        setShowSubmitButtonWarning(false);
    };

    const handleSubmitClickDA = (updateValuesfromChild) => {
        history.push({
            pathname: '/menu/detailAnalysisCore',
            state: { updateValuesfromChild },
        });
    };

    //console.log("thirdscreenvalues.....", thirdscreenvalues);

    const handleSubmitClickForApprove = (updateValuesfromChild) => {
        //console.log("Alahesh", updateValuesfromChild);

        if (updateValuesfromChild.prop) {
            let data = {
                ...updateValuesfromChild.prop,
            };
            dispatch(
                createGenInfoRequestSubmit({
                    params: data,
                    bearerToken,
                    serviceIdValue: servicesID,
                    usertype,
                    tennantnameValue: dbname,
                    statusIDValue: 10,
                })
            );
            setShowLoader(true);
            setTimeout(() => {
                setShowLoader(false);
                // setSuccessPop(true);
            }, 1600);
            setTimeout(() => {
                handleClose();
                history.push({
                    pathname: '/menu/imc-draft-document',
                    state: { statusId },
                });
            }, 1500);
        } else {
            let payload = {
                ...generalInfo,
                ...incomeTaxValues,
                ...initialValues,
                ...thirdscreenvalues,
                ...yesorNoType,
            };

            // dispatch(
            //     createGenInfoRequestSubmit({
            //         params: payload,
            //         bearerToken,
            //         serviceIdValue: servicesID,
            //         usertype,
            //         statusIDValue: 10,
            //     })
            // );
            // setShowLoader(true);
            // setTimeout(() => {
            //     setShowLoader(false);
            //     setSuccessPop(true);
            // }, 1500);

            setShowLoader(true);
            setTimeout(() => {
                setShowLoader(false);
            }, 1600);
            userType.value = 'Detailed Analysis';
            setTimeout(() => {
                setShowLoader(true);
                history.push({
                    pathname: '/menu/detailAnalysisCore',
                    state: { payload },
                });
            }, 1500);
        }
    };

    const handleCancel = () => {
        // setCancel(true);
        history.push({
            pathname: '/menu/openservice',
        });
    };

    const handleConfirmation = () => {
        // setCancel(false);
        history.push({
            pathname: '/menu/openservice',
        });
    };
    const callOpenServiceClose = () => {
        setCancel(false);
    };
    const handleChangeParent = (prop) => {
        // console.log("handleChangeParent", prop);
        setUpdateValuesfromChild({ prop });
        // setApicallFlag(true);
    };

    const handleCRCAccordin = () => {
        cacheservice.sendCRCView();
    };

    return (
        <div className={classes.root}>
            <>
                {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
                {successpop ? (
                    <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title=" Submitted Successfully" />
                ) : null}
                {successpop2 ? (
                    <SuccessPopUp
                        open={successpop2}
                        showSuccess={successpop2}
                        handleClose={handleClose}
                        title="L2 Checklist Generated Successfully"
                    />
                ) : null}

                <div>
                    <span>
                        <div style={{ margin: '12px', display: 'flex', placeContent: 'flex-end' }}>
                            {relevanceList &&
                                relevanceList.map((user) => (
                                    <span style={{ display: 'flex', marginLeft: '20px', alignItems: 'center' }}>
                                        <div style={{ background: user.color, width: '16px', height: '15px' }}></div>
                                        <div style={{ marginLeft: '6px' }}>{user.name}</div>
                                    </span>
                                ))}
                        </div>
                    </span>
                </div>

                <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                        <Typography className={classes.heading}>General Information</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcGeneralInformation
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            statusId={statusId}
                            apiResponse={apiResponse.question0}
                            bankDetails={initialValues.bankDetails}
                            thirdscreenvalues={thirdscreenvalues}
                            incomeTaxValues={incomeTaxValues}
                            yesorNoType={yesorNoType}
                            travelOutside={initialValues.travelOutside}
                            directorCompany={initialValues.directorCompany}
                            assetHome={initialValues.assetHome}
                            assetNature={initialValues.assetNature}
                            client1={initialValues.client1}
                            client2={initialValues.client2}
                            client3={initialValues.client3}
                            client4={initialValues.client4}
                            client5={initialValues.client5}
                            client6={initialValues.client6}
                            client7={initialValues.client7}
                            client8={initialValues.client8}
                            client9={initialValues.client9}
                            client10={initialValues.client10}
                            labelAdata={initialValues.labelAdata}
                            labelBdata={initialValues.labelBdata}
                            labelCdata={initialValues.labelCdata}
                            labelDdata={initialValues.labelDdata}
                            labelEdata={initialValues.labelEdata}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={handleChangeParent}
                        />
                        {/* <GeneralInformation generalInformationData={setGeneralInformationData} /> */}
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>Bank Account Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcBankDetails
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            apiResponse={apiResponse.question1}
                            generalinfo={generalInfo}
                            thirdscreenvalues={thirdscreenvalues}
                            incomeTaxValues={incomeTaxValues}
                            // crcGeneralInfo={apiResponse.question0}
                            // bankDetails={initialValues.bankDetails}
                            statusId={statusId}
                            travelOutside={initialValues.travelOutside}
                            directorCompany={initialValues.directorCompany}
                            assetHome={initialValues.assetHome}
                            assetNature={initialValues.assetNature}
                            client1={initialValues.client1}
                            client2={initialValues.client2}
                            client3={initialValues.client3}
                            client4={initialValues.client4}
                            client5={initialValues.client5}
                            client6={initialValues.client6}
                            client7={initialValues.client7}
                            client8={initialValues.client8}
                            client9={initialValues.client9}
                            client10={initialValues.client10}
                            labelAdata={initialValues.labelAdata}
                            labelBdata={initialValues.labelBdata}
                            labelCdata={initialValues.labelCdata}
                            labelDdata={initialValues.labelDdata}
                            labelEdata={initialValues.labelEdata}
                            yesorNoType={yesorNoType}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')} onClick={() => handleCRCAccordin()}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>What are the difference sources of income that you have?</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcDifferentSource
                            statusId={statusId}
                            apiResponse={apiResponse.question2}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={updateApiCall}
                            panelID={3}
                            apicallFlag={apicallFlag}
                            onChange1={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4a-content"
                        id="panel4a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>Income tax login password </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcIncomeTax
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            apiResponse={apiResponse.question3}
                            generalinfo={generalInfo}
                            bankDetails={initialValues.bankDetails}
                            thirdscreenvalues={thirdscreenvalues}
                            travelOutside={initialValues.travelOutside}
                            directorCompany={initialValues.directorCompany}
                            assetHome={initialValues.assetHome}
                            assetNature={initialValues.assetNature}
                            client1={initialValues.client1}
                            client2={initialValues.client2}
                            client3={initialValues.client3}
                            client4={initialValues.client4}
                            client5={initialValues.client5}
                            client6={initialValues.client6}
                            client7={initialValues.client7}
                            client8={initialValues.client8}
                            client9={initialValues.client9}
                            client10={initialValues.client10}
                            labelAdata={initialValues.labelAdata}
                            labelBdata={initialValues.labelBdata}
                            labelCdata={initialValues.labelCdata}
                            labelDdata={initialValues.labelDdata}
                            labelEdata={initialValues.labelEdata}
                            yesorNoType={yesorNoType}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            statusId={statusId}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5a-content"
                        id="panel5a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>Have you travelled outside India during the previous year?</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcTravelledOutsideIndia
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            statusId={statusId}
                            generalinfo={generalInfo}
                            apiResponse={apiResponse.question4}
                            bankDetails={initialValues.bankDetails}
                            thirdscreenvalues={thirdscreenvalues}
                            incomeTaxValues={incomeTaxValues}
                            directorCompany={initialValues.directorCompany}
                            assetHome={initialValues.assetHome}
                            assetNature={initialValues.assetNature}
                            client1={initialValues.client1}
                            client2={initialValues.client2}
                            client3={initialValues.client3}
                            client4={initialValues.client4}
                            client5={initialValues.client5}
                            client6={initialValues.client6}
                            client7={initialValues.client7}
                            client8={initialValues.client8}
                            client9={initialValues.client9}
                            client10={initialValues.client10}
                            labelAdata={initialValues.labelAdata}
                            labelBdata={initialValues.labelBdata}
                            labelCdata={initialValues.labelCdata}
                            labelDdata={initialValues.labelDdata}
                            labelEdata={initialValues.labelEdata}
                            yesorNoType={yesorNoType}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            Whether you were director in a company at any time during the previous year?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcDirector
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            statusId={statusId}
                            apiResponse={apiResponse.question5}
                            generalinfo={generalInfo}
                            incomeTaxValues={incomeTaxValues}
                            bankDetails={initialValues.bankDetails}
                            thirdscreenvalues={thirdscreenvalues}
                            travelOutside={initialValues.travelOutside}
                            assetHome={initialValues.assetHome}
                            assetNature={initialValues.assetNature}
                            client1={initialValues.client1}
                            client2={initialValues.client2}
                            client3={initialValues.client3}
                            client4={initialValues.client4}
                            client5={initialValues.client5}
                            client6={initialValues.client6}
                            client7={initialValues.client7}
                            client8={initialValues.client8}
                            client9={initialValues.client9}
                            client10={initialValues.client10}
                            labelAdata={initialValues.labelAdata}
                            labelBdata={initialValues.labelBdata}
                            labelCdata={initialValues.labelCdata}
                            labelDdata={initialValues.labelDdata}
                            labelEdata={initialValues.labelEdata}
                            yesorNoType={yesorNoType}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel7a-content"
                        id="panel7a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>Do you have income/assets from sources outside India?</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcForeignAssets
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            // dbValuesforque6={dbValuesforque6}
                            statusId={statusId}
                            apiResponse={(apiResponse.question6, dbValuesforque6)}
                            yesorNoType={yesorNoType}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel8a-content"
                        id="panel8a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>Does your total income exceeds Rs. 50 Lakhs?</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary} style={{ flexDirection: 'column' }}>
                        <CrcTotalIncome
                            rerenderApi={rerenderApi}
                            rerender={rerender}
                            statusId={statusId}
                            apiResponse={(apiResponse.question7, dbValuesforque7)}
                            yesorNoType={yesorNoType}
                            addAdditionalQue={initialValues.additionalQue}
                            apiData={apiData}
                            updateApiData={updateApiData}
                            serviceIdValue={serviceIdValue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                {checklistADD && checklistADD.length >= 1 ? (
                    <Accordion square expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel8a-content"
                            id="panel8a-header"
                            className="padding10"
                        >
                            <Typography className={classes.heading}>Additional Questions</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary} style={{ flexDirection: 'column' }}>
                            <CRCClientAddAdditional
                                rerenderApi={rerenderApi}
                                rerender={rerender}
                                statusId={statusId}
                                apiResponse={apiResponse.question8}
                                generalinfo={generalInfo}
                                incomeTaxValues={incomeTaxValues}
                                bankDetails={initialValues.bankDetails}
                                thirdscreenvalues={thirdscreenvalues}
                                travelOutside={initialValues.travelOutside}
                                directorCompany={initialValues.directorCompany}
                                assetHome={initialValues.assetHome}
                                assetNature={initialValues.assetNature}
                                client1={initialValues.client1}
                                client2={initialValues.client2}
                                client3={initialValues.client3}
                                client4={initialValues.client4}
                                client5={initialValues.client5}
                                client6={initialValues.client6}
                                client7={initialValues.client7}
                                client8={initialValues.client8}
                                client9={initialValues.client9}
                                client10={initialValues.client10}
                                labelAdata={initialValues.labelAdata}
                                labelBdata={initialValues.labelBdata}
                                labelCdata={initialValues.labelCdata}
                                labelDdata={initialValues.labelDdata}
                                labelEdata={initialValues.labelEdata}
                                yesorNoType={yesorNoType}
                                apiData={apiData}
                                updateApiData={updateApiData}
                                serviceIdValue={serviceIdValue}
                                onChange={handleChangeParent}
                            />
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    ''
                )}

                <Grid item sm={12}>
                    <div className="footer-button">
                        {showLoader ? (
                            <LoaderPopUp
                                showLoader={showLoader}
                                handleClose={handleClose}
                                title="Please wait while the checklist is being submitted"
                            />
                        ) : null}
                        <div className="footer-button">
                            <ul>
                                {usertype === 'EM' || usertype === 'Other employee users'
                                    ? // <li>
                                      //     <Button
                                      //         variant="contained"
                                      //         color="primary"
                                      //         className="buttonnext txt-cap"
                                      //         variant="contained"
                                      //         type="submit"
                                      //         onClick={() => {
                                      //             handleSubmitClickDA(updateValuesfromChild);
                                      //         }}
                                      //     >
                                      //         {/* Continue */}
                                      //     </Button>
                                      // </li>

                                      ''
                                    : ''}
                                <li>
                                    <Button
                                        // disabled={isDisable}
                                        variant="contained"
                                        color="primary"
                                        className="buttonnext txt-cap"
                                        onClick={handleCancel}
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Back
                                    </Button>
                                </li>
                                <li>
                                    <li>
                                        {usertype === 'EM' || usertype === 'Other employee users' ? (
                                            <Button
                                                // disabled={isDisable}
                                                variant="contained"
                                                color="primary"
                                                className="buttonnext txt-cap"
                                                onClick={() => {
                                                    handleSubmitClickForApprove(updateValuesfromChild);
                                                }}
                                                disabled={buttonDisable(stageId, userType.value)}
                                            >
                                                {/* Approve */}
                                                Continue
                                            </Button>
                                        ) : (
                                            <Button
                                                // disabled={isDisable}
                                                variant="contained"
                                                color="primary"
                                                className="buttonnext txt-cap"
                                                onClick={() => {
                                                    handleSubmitClick(updateValuesfromChild);
                                                }}
                                                disabled={buttonDisable(stageId, userType.value)}
                                            >
                                                Submit
                                            </Button>
                                        )}
                                    </li>
                                    {usertype === 'ITeC Team' || usertype === 'EM' || usertype === 'Other employee users' ? (
                                        ''
                                    ) : (
                                        <li>
                                            {(showLoaderSubmit ? (
                                                <LoaderPopUp
                                                    showLoader={showLoaderSubmit}
                                                    handleClose={handleClose}
                                                    title="Please wait while L2 checklist is being generated"
                                                />
                                            ) : null) || (
                                                <Button
                                                    // disabled={isDisable}
                                                    variant="contained"
                                                    color="primary"
                                                    className="buttonnext txt-cap"
                                                    onClick={() => {
                                                        handleSubmitClickforL2(updateValuesfromChild);
                                                    }}
                                                    disabled={buttonDisable(stageId, userType.value)}
                                                >
                                                    Generate L2 Checklist
                                                </Button>
                                            )}
                                        </li>
                                    )}
                                </li>
                            </ul>
                        </div>
                        {/* {cancel && (
                            <CancelDialog
                                cancel={cancel}
                                handleConfirmation={handleConfirmation}
                                callOpenServiceClose={callOpenServiceClose}
                            />
                        )} */}

                        {showSubmitButtonWarning && (
                            <SubmitButtonWarningPopUp
                                showSubmitButtonWarning={showSubmitButtonWarning}
                                irrevelentFieldAccording={irreleventFieldAccordingContainer}
                                handleCloseSubmitButtonErrorPopUP={handleCloseSubmitButtonErrorPopUP}
                            />
                        )}
                    </div>
                </Grid>
            </>
        </div>
    );
}
